import { useTranslation } from 'react-i18next';

import { StatusBadge } from '@treezor/design-system';

import { InfoTooltip } from '@/ui-kit/Tips/InfoTooltip';

import { useKycStatus } from '@/features/kyc/hooks/useKycStatus';

import { IUser } from '@/features/user/store/user.model';

import { KycLevel, KycReview } from '@/features/kyc/store/models/kyc.model';

import { DashboardHelpers } from '@/utils/DashboardHelpers';

interface IKycStatusProps {
  user: IUser;
}

export function KycStatus({ user }: IKycStatusProps) {
  const { t } = useTranslation();

  const { kycLevel, kycReview, kycStatus, kycStatusBadgeProps } = useKycStatus(user);

  return (
    <div className="flex items-center gap-2 whitespace-nowrap">
      <StatusBadge emphasis="low" {...kycStatusBadgeProps} />
      <InfoTooltip
        tooltipInfo={
          <div>
            <p>{`${t('pages.currentProfiles.kyc.documents.preview.forms.treezorStatus')}: ${DashboardHelpers.getStatusLabelTranslation(KycLevel[kycLevel]?.toUpperCase())}/${DashboardHelpers.getStatusLabelTranslation(KycReview[kycReview]?.toUpperCase())}`}</p>
            {kycStatus === 'optional' && <p>{t('pages.currentProfiles.kyc.status.tootlips.optional')}</p>}
            {kycStatus === 'to_submit_to_treezor' && (
              <p>{t('pages.currentProfiles.kyc.status.tootlips.toSubmitToTreezor')}</p>
            )}
          </div>
        }
        infoClassName="min-w-[230px] z-10"
      />
    </div>
  );
}
